import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import AllegatiUploadForm from "./AllegatiUploadForm";
import AllegatiList from "./AllegatiList";
import {ErrorStatusTypes,} from "../common/errorsDeclarations";
import {
    Allegato,
    TipoDocumento,
    AllegatiState,
    uploadAllegato,
    fetchAllegati,
    fetchTipiDocumento,
    deleteAllegato,
} from "./allegatiSlice";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {Typography, Stack, CardHeader} from "@mui/material";
import {theme} from "../theme";

interface AllegatiPageProps {
    dettaglio_richiesta_cliente_id?: number | null;
    previsione_id?: number | null;
    consentiModifica?: boolean// annulla?: () => void;
    light?: boolean;
    color?: string;
}

const AllegatiPage = ({
                          dettaglio_richiesta_cliente_id,
                          previsione_id,
                          consentiModifica,
                          light = false,
                          color = theme.palette.divider
                      }: AllegatiPageProps) => {
        const dispatch = useAppDispatch();

        useEffect(() => {
            dispatch(fetchTipiDocumento());
            dispatch(
                fetchAllegati({
                    previsione_id: previsione_id,
                })
            );
        }, []);

        const tipiDocumento: TipoDocumento[] = useSelector<
            RootState,
            TipoDocumento[]
        >((state) => state.allegati.tipiDocumento.results);

        const allegati: Allegato[] | undefined = useSelector<
            RootState,
            Allegato[] | undefined
        >((state) =>
            state.allegati.allegati.results.filter((allegato) => {
                if (previsione_id) {
                    return (allegato.previsione === previsione_id);
                }
                return false;
            })
        );

        const allegatoCorrente: AllegatiState | undefined = useSelector<
            RootState,
            AllegatiState | undefined
        >((state) => state.allegati.allegatoCorrente);

        // const [poiChiudi, setPoiChiudi] = useState(false);

        const [collapseList, setCollapseList] = useState<boolean>(!light);

        const handleUploadAllegato = (allegato: Allegato, selectedFile: File | null) => {
            console.log("uploadAllegato allegato:", allegato);

            selectedFile && consentiModifica &&
            dispatch(
                uploadAllegato({
                    allegato: allegato,
                    file: selectedFile,
                })
            );
        };

        const handleDelete = (allegato: Allegato) => {
            consentiModifica && dispatch(deleteAllegato(allegato));
        };

        return (
            <Card sx={{ mb: 2}}>
                <CardHeader
                    sx={{backgroundColor: color}}
                    title={
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="h6" color="white">
                                    Allegati {allegati ? `(${allegati.length})` : ''}
                                </Typography>
                                {light &&
                                    <IconButton
                                        sx={{px: 0, pr: 0.5, color: 'purple'}}
                                        // component={Link}
                                        color="primary"
                                        // to={{pathname: Routes_path.ATTIVITA + attivita.id}}
                                        onClick={() => setCollapseList(!collapseList)}
                                    >
                                        <AttachFileIcon/>
                                    </IconButton>
                                }
                            </Stack>

                            {/* DESTRA: pulsanti azione */}
                            <Stack direction="row" spacing={1}>
                                {consentiModifica &&
                                    <AllegatiUploadForm
                                        allegato={{
                                            id: null,
                                            tipo_documento: 1,
                                            descrizione: "",
                                            previsione: previsione_id,
                                            autore: "",
                                            file: "",
                                        }}
                                        tipiDocumento={tipiDocumento}

                                        uploadAllegato={handleUploadAllegato}
                                        uploading={
                                            allegatoCorrente?.errorsStack.status == ErrorStatusTypes.PENDING
                                        }
                                    />
                                }
                            </Stack>
                        </Stack>
                    }
                />
                {collapseList &&


                    <CardContent>
                        {allegati && (
                            <AllegatiList allegati={allegati} handleDelete={handleDelete}
                                          consentiModifica={consentiModifica}/>
                        )}
                    </CardContent>
                }
            </Card>

        )
    }
;

export default AllegatiPage;
